import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import {LoginComponent} from '../login/login.component';
import { NgForm } from '@angular/forms';
import { from } from 'rxjs';

// Services
import { LocationService } from '../../services/location.service';
import { CustomPageService } from '../../services/custom-page.service';
import { GlobalFlagsService } from '../../services/global-flags.service';
import { OAuthService } from '../../services/oauth.service';
import { DialogService } from '../../services/dialog.service';
import { RegistrationService } from '../../services/registration.service';
import { StorageService } from '../../services/storage.service';
import { ModuleService } from '../../services/modules.service';
import { CookieService } from 'ngx-cookie';

import { FormBuilder, FormGroup } from '@angular/forms';
import { UserFormActions } from '../user/user-form-actions';
import { UserForm } from '../../models/UserForm';
import { TranslateService } from '@ngx-translate/core';

import * as moment from 'moment';
import posthog from "posthog-js";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-start-survey',
  templateUrl: './start-survey.component.html',
  styleUrls: ['./start-survey.component.scss'],
  providers: [LoginComponent]
})
export class StartSurveyComponent implements OnInit {
  _dobValid: boolean = false;
  logo = "menu_logo.png";
  get dobValid() {
    return this._dobValid;
  }
  set dobValid(value: boolean) {
    this._dobValid = value;
  }

  constructor(private route: ActivatedRoute,
    private router: Router,
	  private registrationService: RegistrationService,
    private locationService: LocationService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private customPageService: CustomPageService,
    private globalFlagsService: GlobalFlagsService,
    private oAuthService: OAuthService,
    private storageService: StorageService,
    private dialogService: DialogService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private moduleService: ModuleService) {

    this.translate.addLangs(['EN', 'FR', 'UR', 'ES', 'IT', 'FA', 'DE', 'ZH-CHS']);
        this.translate.setDefaultLang('EN');
        const browserLang = this.translate.getBrowserLang();
        this.translate.use(/EN|FR|UR|ES|IT|FA|DE|ZH-CHS/.exec(browserLang) ? browserLang : 'EN');
  }

  public href: string = "";
  dev = false;
  loggedInLocalhost = false;
  posthogEnabled = false;

  @ViewChild(StartSurveyComponent)
  public startSurveyComponent: StartSurveyComponent;

  viewObj = {
    htmlContent: null,
    name: null
  };

  token = null;
  started=null;
  customTextVerification = null;

  invalidAccess;

  action = UserFormActions.Register;
  userDetails: UserForm = new UserForm();

  formCreated = false;
  verifyBOD:boolean = false;

  languages: any;
  language: any;
  multipleLanguage: any;
  languageId: number = 1;


  editUserForm: FormGroup;

  private sub;
  private res;

  birthDate = {
    day: null,
    month: null,
    year: null
  };
  yearsArr = Array();
  monthsArr = moment.months();
  daysArr = Array();

  isFieldInvalid(field: any) {
    const fieldFlags = this.editUserForm.get(field);
    return (fieldFlags.invalid && (fieldFlags.dirty || fieldFlags.touched));
  }


  ngOnInit() {
    this.oAuthService.logout();
    let er;
    this.globalFlagsService.displayLoad(true);

    // this.sub = this.route.queryParams.subscribe(params => {
    //   this.token = params['token'];
    //   const obj = {
    //     'token': this.token
    //   };

    this.sub = this.route.params.subscribe(params => {
      // If token is in the route, use it
      if (params['token']) {
        this.token = params['token'];
      } else {
        // If token is in the query params, use it
        this.route.queryParams.subscribe(queryParams => {
          this.token = queryParams['token'];
        });
      }
      // If started is in the route, use it
      if (params['started']) {
        this.started = params['started'];
      } else {
        // If Started is in the query params, use it
        this.route.queryParams.subscribe(queryParams => {
          this.started = queryParams['started'];
        });
      }


        const obj = {
          'token': this.token,
          'started':this.started
        };
      this.href = window.location.origin;
      this.dev = this.href.includes("dev");
      this.loggedInLocalhost = environment.url.api.includes("localhost");
      // Posthog logging for PROD only. Set variable true to work aftewrads.
     /* if(environment.production) {
        posthog.init(environment.posthog.token,environment.posthog.config);
        this.globalFlagsService.setPosthogEnabled(true);
      }
      else{
        this.globalFlagsService.setPosthogEnabled(false);
      }*/
      this.globalFlagsService.setPosthogEnabled(false);
      this.validateToken(obj);
	    this.populateDatesArr();
    });
  }

  getLabel() {
    try {
        let optionFound = this.customTextVerification.filter(x => x.language !== null && x.language !== undefined && x.language === this.languageId)[0];
        if (optionFound?.customLabel && optionFound.customLabel !== '')
          return optionFound.customLabel;
        else {
          return this.customTextVerification[0].customLabel;
        }
    }
    catch (Exception) {
      return '';
    }
  }


  validateToken(obj : any) {
    const confirmation = from(this.registrationService.checkIsValidTokenInstance(obj));
    confirmation
      .subscribe((res: any) => {
        if (res?.languageCode != null) {
          this.translate.use(res.languageCode);
          this.globalFlagsService.displayLoad(false);
          this.customTextVerification = res.formLabelViewModelList;
        }
        else{
          this.globalFlagsService.displayLoad(false);
          this.dialogService.openErrorDialogRedirectLogin({ title: 'Error', message: 'Invalid link' });
        }
        this.languages = res.languages;
        this.multipleLanguage = res.multipleLanguage;
        if(res.languageCode == 'EN')
          this.cookieService.put('formLanguage', '1');
        else if(res.languageCode == 'ES')
          this.cookieService.put('formLanguage', '2');
        else if(res.languageCode == 'RU')
          this.cookieService.put('formLanguage', '5');
        else if(res.languageCode == 'ZH')
          this.cookieService.put('formLanguage', '3');
        else if(res.languageCode == 'AR')
          this.cookieService.put('formLanguage', '4');
        else if(res.languageCode == 'PL')
          this.cookieService.put('formLanguage', '6');
        else if(res.languageCode == 'KO')
          this.cookieService.put('formLanguage', '7');
        else
          this.cookieService.put('formLanguage', '1');
        this.languageId = Number(this.cookieService.get('formLanguage'));
        this.cookieService.put('formId', res.formId);
        if(!res.verifyDob){
          console.log("verifyDob is false")
          this.onClickDate();
        }
        else{
          this.verifyBOD = true;
        }
      }, (error: any) => {
        console.log(error);
        this.dialogService.openErrorDialogRedirectLogin({ title: 'Error', message: 'The selected link is not valid anymore or it belongs to a screener that has expired.' });
      });
  }


  populateDatesArr() {
    const firstYear = 1900;
    const actualYear = moment().year();
    for (let i = firstYear; i <= actualYear; i++) {
      this.yearsArr.push(i);
    }
    this.yearsArr = this.yearsArr.sort((a, b) => a > b ? -1 : 1);
    this.daysArr = Array(31).fill(0).map((e, i) => i + 1);

  }


  onClickDate() {
    let obj;
    if (this.birthDate.day != null && this.birthDate.month != null && this.birthDate.year != null) {
      const month = moment().month(this.birthDate.month).format('M');
      obj = {
        'token': this.token,
        'dateOfBirth': `${month}/${this.birthDate.day}/${this.birthDate.year}`,
        started:this.started
      };
    } else {
      obj = {
        'token': this.token,
        'dateOfBirth': null,
        started:this.started
      }
    }
    this.globalFlagsService.displayLoad(true);

    const confirmation = from(this.registrationService.confirmDOBStartInstance(obj));
    confirmation
      .subscribe((res: any) => {
        if (res != null) {
          this.dobValid = true;
          if (res.oAuth2AccessToken != undefined){
            this.oAuthService.logout();
            this.oAuthService.authenticate(res.oAuth2AccessToken);
            this.globalFlagsService.setUserLogged(true);
            this.globalFlagsService.setIsFromLogin(true);
            if (res.headerViewModel != null){
              // Check if posthog is enabled and send user id to be identified in posthog log server
              if(this.globalFlagsService.isPosthogEnabled){
                posthog.identify(res.oAuth2AccessToken.userId,{
                  provider: res.headerViewModel.idHospital
                });
                console.log("posthog.identifying: " + (res.oAuth2AccessToken.userId));
              }
                this.storageService.setUsername(res.headerViewModel.userFirstName);
                this.storageService.setIdHospital(res.headerViewModel.idHospital);
                this.storageService.setClinic(res.headerViewModel.clinic);
                this.storageService.setShowName(res.headerViewModel.showName);
                OAuthService.saveAppModules(res.headerViewModel.appModules);
                OAuthService.saveLanguage(res.headerViewModel.lang);
                OAuthService.saveLanguageCode(res.headerViewModel.langCode);
                this.translate.use(res.headerViewModel.langCode);
            }

          if(this.moduleService.isLocalResourcesAvailable())
          {
            const localResources = from(this.customPageService.getLocalResources());
            localResources
            .subscribe(() => { },
            err => {
              localStorage.setItem('disableLocalResources', 'true');
            });
          }
          if(this.moduleService.isHelpLineAvailable()) {
            const helpLine = from(this.customPageService.getHelpLine());
            helpLine
            .subscribe(() => { },
            err => {
              localStorage.setItem('disableHelpLine', 'true');
            });
          }
            if (res.formInstanceId != null){
                this.router.navigate(['/form/startInstance/', res.formInstanceId]);
            }
          }
          else{
            this.dobValid = false;
            let message;
            this.translate.get('Incorrect date of birth. Please try again.').subscribe((res: string) => {
              message = res;
            });
            this.dialogService.openErrorDialog({ message });
          }

        } else {
          this.dobValid = false;
          let message;
          this.translate.get('Incorrect date of birth. Please try again.').subscribe((res: string) => {
            message = res;
          });
          this.dialogService.openErrorDialog({ message });
        }
        this.globalFlagsService.displayLoad(false);
      });
  }

  changeLanguage() {
    this.cookieService.put('formLanguage', this.languageId.toString());
    OAuthService.saveLanguage(this.languageId);
    switch (this.languageId) {
      case 1:
        OAuthService.saveLanguageCode('EN');
        break;
      case 2:
        OAuthService.saveLanguageCode('ES');
        break;
      case 3:
        OAuthService.saveLanguageCode('ZH');
        break;
      case 4:
        OAuthService.saveLanguageCode('AR');
        break;
      case 5:
        OAuthService.saveLanguageCode('RU');
        break;
      case 6:
        OAuthService.saveLanguageCode('PL');
        break;
      case 7:
        OAuthService.saveLanguageCode('KO');
        break;
      default:
        OAuthService.saveLanguageCode('EN');
        break;
    }
    this.translate.use(OAuthService.getLanguageCode());
    localStorage.setItem('lang', this.languageId.toString());
  }

  get changedLanguage() {
    return Number(localStorage.getItem('changedLanguage'));
  }

}
